export enum MinionName {
	TEAMWORK_AGENT = 'TeamworkAgent',
	SEARCH = 'search',
}
